// extracted by mini-css-extract-plugin
export default {"title":"BannerTitle_title__F1z0a"};